import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  IGetMotoristasExternoParams,
  IGetMotoristasExternoResponse,
  IMotoristaExternoDto
} from './motorista-externo.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MotoristaExternoService {
  constructor(private http: HttpClient) {}

  public GetMotoristasExterno(
    params: IGetMotoristasExternoParams
  ): Observable<IGetMotoristasExternoResponse> {
    params.PAGE_NUMBER = params.PAGE_NUMBER || 1;

    const invalidParams = ['', null, undefined, NaN, 0];

    const validParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => !invalidParams.includes(value)
      )
    );

    return this.http.get<any>(
      `${environment.baseURL}MotoristaExterno/GetMotoristasExterno`,
      { params: validParams }
    );
  }

  public GetMotoristaExternoByNome(nome: string): Observable<IMotoristaExternoDto> {
    return this.http.get<IMotoristaExternoDto>(
      `${environment.baseURL}MotoristaExterno/GetMotoristaExternoByNome`,
      { params: { nome } }
    );
  }
}
